<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="选择日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>用户付费区间玩家平均时长</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="level"
            label="等级"
            align="center"
          />
          <el-table-column
            prop="p0"
            label="未付费"
            align="center"
          />
          <el-table-column
            prop="p1"
            label="付费(0.99-4.99)"
            align="center"
          />
          <el-table-column
            prop="p2"
            label="付费(5-9.99)"
            align="center"
          />
          <el-table-column
            prop="p3"
            label="付费(10-49.99)"
            align="center"
          />
          <el-table-column
            prop="p4"
            label="付费(>49.99)"
            align="center"
          />
        </el-table>
      </el-card>

      <el-card>
        <div slot="header" class="clearfix">
          <span>分布曲线</span>
        </div>
        <stat ref="data" />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { getUserPayOnlineStat } from '@/api/user/user_info'
import { getRidTypeList } from '@/api/config/reward-record'
import stat from '@/views/config/pay-user-stat/components/stat.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
export default {
  name: 'PayUserStat',
  components: {
    stat
  },
  data() {
    return {
      total: 0,
      loading: false,
      rewardType: [
        { label: '金币', value: 14 },
        { label: '体力', value: 15 },
        { label: '钻石', value: 22 },
        { label: '野兽币', value: 65 }
      ],
      queryParams: {
        startDate: '',
        level: 14,
        uid: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserPayOnlineStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.tableData = res.data
          this.$refs.data.refresh(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRidData() {
      getRidTypeList().then(res => {
        this.ridData = res.data
      })
    }
  }
}
</script>

<style scoped>
</style>
